export const PageNotFoundText = {
    title: {
        en: "404 - Page Not Found!",
        mr: "कोणतेही प्रमाणपत्र सापडले नाही!",
    },
    description: {
        en: "The requested URL was not found on this server.",
        mr: "सध्याचा अनुरोध केलेला पत्ता सापडलेला नाही.",
    },
    button: {
        en: "Go back",
        mr: "परत जा",
    },
};
